const IMPERSONATE_PATH = '/auth/impersonate';

export function buildImpersonationUrl(
  frontUrl,
  { accessToken, expiresAt, adminEmail, userLoginId },
) {
  const url = new URL(IMPERSONATE_PATH, frontUrl);
  const fragment = new URLSearchParams({
    token: accessToken,
    expiresAt: String(expiresAt),
    adminEmail,
  });

  if (userLoginId) {
    fragment.set('userLoginId', String(userLoginId));
  }

  url.hash = fragment.toString();

  return url.href;
}
